import React from "react";
import DocumentItem from "./DocumentItem";

export default function DocumentList({ mediaObjects }) {
  const documents = mediaObjects && mediaObjects.map(DocumentItem);

  return (
    <div className='gallery-contents' id="gallery-contents">
      <ul className='list-unstyled'>
        {documents}
      </ul>
    </div>
  );
}
